export default "../images/stackloans-partners-with-marcus-by-goldman-sachs.png?28e290725825561147060bce9f5a120f";